// extracted by mini-css-extract-plugin
export default {"btn":"ToolButton_btn__KoVNr","active":"ToolButton_active__taksh"};